import '../less/main.less'; // Import the main LESS file

import App from './app/app.js';
import config from './app/config.js';

App.init(config);